import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Checkbox, Space, Spin } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { isFunction } from "lodash";
import useMessageForwardOptions from "../../../../hooks/useMessageForwardOptions";

const NotesPreferences = ({ onChange }) => {
  const { forwardOptions: settings, loading: forwardLoading } = useMessageForwardOptions();
  const [localSettings, setLocalSettings] = useState(settings);
  const [availableOptions, setAvailableOptions] = useState([]);
  const hasCalledOnChangeRef = useRef(false);

  // Update local settings and determine available options when hook settings change
  useEffect(() => {
    setLocalSettings(settings);
    // Store which options are available (true from server) - these will always be shown
    const available = Object.entries(settings)
      .filter(([key, val]) => val === true)
      .map(([key]) => key);
    setAvailableOptions(available);

    // Call onChange immediately when preferences are loaded from server (only once)
    // This ensures the parent components have access to preferences without waiting for user interaction
    if (isFunction(onChange) && Object.keys(settings).length > 0 && !hasCalledOnChangeRef.current) {
      hasCalledOnChangeRef.current = true;
      onChange(settings);
    }
  }, [settings]); // Added forwardLoading to dependencies to track when server response arrives

  const onToggle = name => e => {
    const next = { ...localSettings, [name]: e.target.checked };
    setLocalSettings(next);
    if (isFunction(onChange)) onChange(next);
  };

  const dropdownContent = (
    <div className="p-3 bg-white rounded shadow-sm" onClick={e => e.stopPropagation()}>
      {forwardLoading ? (
        <div className="flex items-center justify-center p-4">
          <Spin tip="Loading..." />
        </div>
      ) : (
        <Space direction="vertical">
          <div className="text-black/[0.88] text-sm font-semibold mb-2">Send messages via</div>
          {availableOptions.map(key => {
            const labelMap = {
              isForwardEmail: "Email",
              isForwardSms: "Sms",
              isForwardNotification: "Notification",
            };
            return (
              <Checkbox key={key} checked={!!localSettings[key]} onChange={onToggle(key)}>
                {labelMap[key] || key}
              </Checkbox>
            );
          })}
        </Space>
      )}
    </div>
  );

  return (
    <Dropdown overlay={dropdownContent} trigger={["click"]} placement="bottomRight">
      <SettingOutlined style={{ color: "#00000045", fontSize: 18, cursor: "pointer" }} />
    </Dropdown>
  );
};

export default NotesPreferences;
